import { LoanPurpose } from '@mortgage-pos/types'

// MQ rejects refi rate requests with waiveEscrow=true above this LTV
// ("Escrow Waiver >80% LTV Not Allowed (OVERLAY)").
export const ESCROW_WAIVER_MAX_LTV = 80

// Refi waives by default but never above the LTV ceiling. Non-refi never waives.
export function calculateEffectiveWaiveEscrow(
  loanPurpose: LoanPurpose | null | undefined,
  loanToValue: number
): boolean {
  if (loanPurpose !== LoanPurpose.Refinance) {
    return false
  }

  return loanToValue <= ESCROW_WAIVER_MAX_LTV
}
